export default {
  resource: "admin.adminPlugins.show",
  path: "/plugins",

  map() {
    this.route("community-feedback-structure", { path: "feedback-structure" });
  },
};
